import { dropShadows } from "style/DropShadows";

/*Default theme for the application. Here we can add base themes, component specific themes etc.*/
export const defaultTheme = {
  ...dropShadows,
};
